import React, { useState, useEffect } from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import IconButton from '@material-ui/core/IconButton'

import useMediaPath from 'hooks/useMediaPath'
import { Q_MFT_MODELS } from 'graphql/query'
import styles from '../vehicle.module.scss'
import Loading from 'components/Global/Loading'
import PreviewComponent from 'components/Global/Preview'

const Models = ({ mftId, setSelected }) => {
  const [models, setModels] = useState([])
  const [loading, setLoading] = useState(true)
  const mediaPath = useMediaPath()
  let { url } = useRouteMatch()

  const history = useHistory()

  const updateUrl = link => {
    history.push(link)
  }

  const { refetch } = useQuery(Q_MFT_MODELS, {
    variables: {
      id: parseInt(mftId),
    },
  })
  useEffect(() => {
    refetch() &&
      refetch().then(res => {
        setModels(res.data.rManufacturer[0].vehiclemodelSet)
        setLoading(false)
      })
  }, [refetch])

  return !loading ? (
    <div className={styles.content}>
      {models &&
        models.map((model, i) => (
          <div className={styles.cardWrapper} key={i}>
            <PreviewComponent
              title={model.name}
              details={model.details}
              preview={mediaPath(model.image.image)}
              componentType="thumbnail"
              previewSize={[400, 200]}
              iconCardWidth={100}
              onClickFn={() => {
                setSelected(model.id)
                updateUrl(`${url}/${model.name}`)
              }}
            />{' '}
          </div>
        ))}
    </div>
  ) : (
    <Loading />
  )
}

export default Models
